import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as adminHistoryService from '../services/adminHistory';

const initialState = {
  history: [],
  isFetching: false,
  error: null
};

const sliceName = 'adminHistory';

export const fetchNextHistory = createAsyncThunk(
  `${sliceName}/fetchNext`,
  (args, thunkAPI) => {
    return adminHistoryService
      .getAdminHistory(args.filters, args.sort, args.limit, args.offset)
      .catch((error) => {
        error.clientMessage = "Can't get admin history from server";
        return thunkAPI.rejectWithValue(error)
      });
  }
);

export const fetchStartHistory = createAsyncThunk(
  `${sliceName}/fetchStart`,
  (args, thunkAPI) => {
    return adminHistoryService
      .getAdminHistoryWithTotal(args.filters, args.sort, args.limit)
      .catch((error) => {
        error.clientMessage = "Can't get admin history from server";
        return thunkAPI.rejectWithValue(error)
      });
  }
);

const adminHistory = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: {
    [fetchStartHistory.fulfilled]: (state, action) => {
      const { history, total } = action.payload;
      state.isFetching = false;
      state.history = [...history, ...new Array(total - history.length).fill(null)];

    },
    [fetchNextHistory.fulfilled]: (state, action) => {
      const { offset } = action.meta.arg;
      const history = action.payload;
      const { length } = history;
      state.isFetching = false;
      state.history = [
        ...[...state.history].splice(0, offset),
        ...history,
        ...[...state.history].splice(
          offset + length,
          state.history.length - (offset + length)
        ),
      ];
    },

    [fetchStartHistory.pending]: (state) => {
      state.isFetching = true;
      state.error = null;
      state.history = [];
    },
    [fetchNextHistory.pending]: (state) => {
      state.isFetching = true;
      state.error = null;
    },

    [fetchStartHistory.rejected]: (state, action) => {
      state.isFetching = false;
      state.error = action.payload;
    },
    [fetchNextHistory.rejected]: (state, action) => {
      state.isFetching = false;
      state.error = action.payload;
    },
  }
});

const { reducer } = adminHistory;

export const adminHistorySelectors = {
  adminHistoryState: (state) => state.adminHistory,
}

export default reducer;



// WEBPACK FOOTER //
// ./src/store/adminHistorySlice.js